module.exports = __webpack_public_path__ + "img/rura-okragla.49516325.jpg";